import { render, staticRenderFns } from "./TreeLevel.vue?vue&type=template&id=2401950a"
import script from "./TreeLevel.vue?vue&type=script&lang=js"
export * from "./TreeLevel.vue?vue&type=script&lang=js"
import style0 from "./TreeLevel.vue?vue&type=style&index=0&id=2401950a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports